import { fetchAPI } from './shared';
import { DividendRecord } from '../types/hiro';

export const getDividends = async (
  sym: string,
  options?: {
    start?: string;
    end?: string;
    excludeForecast?: boolean;
  },
): Promise<DividendRecord[]> => {
  const params = new URLSearchParams({ sym });
  if (options?.start != null) {
    params.append('start', options.start);
  }
  if (options?.end != null) {
    params.append('end', options.end);
  }
  if (options?.excludeForecast != null) {
    params.append('exclude_forecast', 'true');
  }

  // fetchAPI returns Promise<any>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return fetchAPI(`v1/dividends?${params.toString()}`);
};
